import axios from "axios";

const attendMe2 = axios.create({
  baseURL: "https://esystems.cdl.lk/backend-test/AttendMe2",
});

// Forward auth token from the default axios instance.
attendMe2.interceptors.request.use((config) => {
  const token =
    axios.defaults.headers.common["Authorization"] ||
    axios.defaults.headers.common["token"];
  if (token) config.headers["Authorization"] = token;
  return config;
});

const OTAllocatedService = {
  // Fetch Supervisor Wise OT
  async getSupWiseOT(date) {
    try {
      const response = await attendMe2.get(`/SupWiseOT/GetSupWiseOT?p_date=${date}`);
      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching Supervisor Wise OT:", error);
      throw error;
    }
  },

  // Fetch Location Not Off
  async getLocationNotOff(date) {
    try {
      const response = await attendMe2.get(`/LocationNotOff/GetLocationNotOff?p_date=${date}`);
      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching Location Not Off:", error);
      throw error;
    }
  },

  // Fetch OT Emp Not Left
  async getOTEmpNotLeft(date) {
    try {
      const response = await attendMe2.get(`/OTEmpNotLeft/GetOTEmpNotLeft?p_date=${date}`);
      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching OT Emp Not Left:", error);
      throw error;
    }
  },
};

export default OTAllocatedService;
